import { render, staticRenderFns } from "./layout-product-promos.vue?vue&type=template&id=bab78cde&scoped=true&"
import script from "./layout-product-promos.vue?vue&type=script&lang=js&"
export * from "./layout-product-promos.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-promos.vue?vue&type=style&index=0&id=bab78cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab78cde",
  null
  
)

export default component.exports